import { sortBy, uniq } from 'lodash';

import { axios as axios_new_api } from '@/store/config';

export default {
  // state
  state: {
    errorReportDraft: null,
  },
  // getters
  getters: {
    getErrorReportDraft(state) {
      return state.errorReportDraft;
    },

    getErrorReportRows(state) {
      if (!state.errorReportDraft) return [];

      return state.errorReportDraft.rows;
    },

    getErrorReportRowById: (state, getters) => (id) => {
      return getters.getErrorReportRows.find((r) => r.id == id);
    },

    /**
     * Skicka in text och kolla om den innehåller någon av orden som ska skrivas ut ett felmeddelande på
     */
    errorReportDescriptionIncludeKeywords: (state, getters) => (text) => {
      if (!text) return;

      const keywordRows = getters.webapp_config.msg.errorreport_create_description_keywords;

      const words = text.split(/[ -,.!?\n]+/gi).map((w) => w.toLowerCase().trim());

      let found = [];

      keywordRows.forEach((keywordRow) => {
        // Gör om rader av nyckelord till en array
        const keywords = keywordRow.keywords.split('\n').map((w) => w.toLowerCase().trim());

        keywords.forEach((kw) => {
          if (words.indexOf(kw) !== -1) {
            found.push(keywordRow.text);
          }
        });
      });

      if (found.length == 0) return;

      return uniq(found);
    },
  },

  // actions
  actions: {
    createErrorReportDraft({ commit, dispatch }) {
      console.log("createErrorReportDraft")
      return new Promise((resolve, reject) => {
        commit('setErrorReportDraftData', {
          rows: [],
          access: {
            masterKey: null,
            phone: null,
            callBetween: null,
          },
          pet: false,
        });

        resolve();
      });
    },

    updateErrorReportRow({ dispatch, commit }, row) {
      return new Promise((resolve, reject) => {
        commit('updateErrorReportRow', row);
        resolve();
      });
    },

    newErrorReportRow({ dispatch, commit, getters }) {
      return new Promise((resolve, reject) => {
        const newRowId = `${Math.random().toString(36).slice(2, 9)}`;
        commit('updateErrorReportRow', {
          id: newRowId,
          areaCode: null,
          rentalObjectCode: null,
          locationCode: null,
          locationId: null,
          partCode: null,
          partCodeName: null,
          parentId: null,
          subPartCode: null,
          description: '',
          blueprint: null,
          images: [],
        });
        resolve(newRowId);
      });
    },

    setErrorReportDraftData({ dispatch, commit }, data) {
      commit('setErrorReportDraftData', data);
    },

    submitErrorReportDraft({ dispatch, commit, state }) {
      const draft = state.errorReportDraft;
      console.log(JSON.parse(JSON.stringify(draft)))

      const row = draft.rows[0];

      let entityId = null;
      if (row.areaCode === 'apartment') {
        entityId = row.locationId || row.laundryCode || null;
      } else if (row.areaCode === 'laundryroom' || row.areaCode === 'playground') {
        entityId = row.laundryCode || null;
      }

      let category1 = 0, category2 = 0, category3 = 0, category4 = 0;

      if (row.areaCode === 'laundryroom' || row.areaCode === 'playground') {
        category1 = row.parentId || 0;
        category2 = row.locationId && row.locationId != row.parentId ? row.locationId : row.partCode;
        category3 = row.locationId && row.locationId != row.parentId ? row.partCode : row.subPartCode;
        category4 = row.locationId && row.locationId != row.parentId ? row.subPartCode : 0;
      }
      else if (row.areaCode === 'apartment') {
        category1 = row.parentId || 0;
        category2 = row.partCode || 0;
        category3 = row.subPartCode || 0;
        category4 = 0;
      }
      else {
        if (row.locationId && row.locationId != row.partCode) {
          category1 = row.locationId;      // Den används inte om entityId = locationId
          category2 = row.partCode || 0;
          category3 = row.subPartCode || 0;
        } else {
          category1 = row.partCode || 0;
          category2 = row.subPartCode || 0;
        }
      }

      if (!category3) category3 = 0;
      if (!category4) category4 = 0;

      const errorReport = {
        pet: draft.pet && draft.pet.pet != false ? draft.pet.pet : 'notstated',
        leaseId: draft.rows[0].rentalObjectCode,
        entityId,
        description: draft.rows[0].description,
        key: draft.access.masterKey == null ? 'call' : draft.access.masterKey,
        categories: {
          category1,
          category2,
          category3,
          category4
        },
        files: draft.rows[0].images.map((img, index) => ({
          fileName: img.fileName ?? "img" + index,
          content: img.data
        })),
        workordertype: draft.rows[0].areaCode,
        preferredtimefrom: draft.access.callBetween && draft.access.callBetween.from,
        preferredtimeto: draft.access.callBetween && draft.access.callBetween.to,
        phone: draft.access.phoneNumber
      };

      console.log(JSON.parse(JSON.stringify(errorReport)))


      return axios_new_api
        .post('/workorders', errorReport)
        .then((response) => {
          return dispatch('createErrorReportDraft').then(() => {
            return dispatch('newErrorReportRow');
          });
        })
        .catch((error) => {
          /*if(Array.isArray(error.response.data)){
          let errorIds = [];

          error.response.data.forEach(row => {
            if(! row.error){
              dispatch('deleteErrorReportRow', row.item)
            } else {
              errorIds.push(row.item);
            }
          });

          if(!!errorIds.length)
            return Promise.reject(error);
        }*/

          return Promise.reject(error);
        });
    },

    deleteErrorReportRow({ dispatch, commit }, id) {
      return new Promise((resolve, reject) => {
        commit('deleteErrorReportRow', id);
        resolve();
      });
    },
  },

  // mutations
  mutations: {
    updateErrorReportRow(state, row) {
      console.log("SAVE ROW", row)
      const rows = [];//state.errorReportDraft.rows.filter((r) => r.id != row.id);
      rows.push(row);
      state.errorReportDraft.rows = rows;
    },

    setErrorReportDraftData(state, data) {
      state.errorReportDraft = { ...state.errorReportDraft, ...data };
    },

    deleteErrorReportRow(state, id) {
      state.errorReportDraft.rows = state.errorReportDraft.rows.filter((r) => r.id !== id);
    },
  },
};
